
import TagsService from "external-services/tags-service/index";
import AdminService from "external-services/diary-admin-service/admin.service";
import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'SetupService';

export default function SetupService($q, $http, $log) {
  "ngInject";

  var service = {
    deleteAll: deleteAll,
    addBookingStatus: addBookingStatus,
    addTagTypes: addTagTypes
  };

  function deleteAll() {
    return PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: true
    }).then(function (results) {
      return Promise.all(results.rows.map(function (row) {
        return PouchLoadService.getDbLocal().remove(row.doc);
      }));
    }).catch(function (err) {
      $log.log(err);
    });
  }

  function addBookingStatus() {
    return $http.get('json/defaultStatus.json').then(function (response) {
      var statusList = response.data;
      for (var i = 0; i < statusList.length; i++) {
        var status = statusList[i];
        status.order = i;
        status.type = 'status';
      }
      return PouchLoadService.getDbLocal().bulkDocs(statusList);
    });
  }

  function addTagTypes() {
    // load default tag
    return $http.get('json/defaultTagTypes.json').then(function (response) {
      var types = response.data;
      return PouchLoadService.getDbLocal().bulkDocs(types).then(function () {
        return addTags(types);
      });
    });
  }

  /** @private */
  function addTags(tagtypes) {
    var tagtypesLookUp = {};
    for (var i = tagtypes.length - 1; i >= 0; i--) {
      var tagtype = tagtypes[i];
      tagtypesLookUp[tagtype._id] = tagtype;
    }

    // load default tag
    return $http.get('json/defaultTags.json').then(function (response) {
      var tags = response.data;
      // if not an online venue, add shared tags placeholders
      if (!AdminService.getVenue().isOnlineCustomersEnabled) {
        tags.push(TagsService.vipTag);
        tags.push(TagsService.noShowTag);
      }
      // add the tag type to tag doc
      for (var i = tags.length - 1; i >= 0; i--) {
        var tag = tags[i];
        tag._id = (tag._id) ? tag._id : PouchLoadService.getNewId(['tag']);
        tag.order = i;
        tag.tagtype = tagtypesLookUp[tag.tagtype];
      }
      return PouchLoadService.getDbLocal().bulkDocs(tags);
    });
  }

  return service;
}
